



























import { Component, Vue, Emit } from 'vue-property-decorator'
import { QueryExpressCompanyList , UpdateExpressOrder,QueryOrderGoodsDescList} from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VTable } from '@/components/table'
import { TableHander } from '@/components/table'
import { PriceFormat } from '@/utils/tyepconvert'

@Component({
  components: { VTable }
})
export default class UpdateShippedDialog extends Vue {
  private show = false
  private orderInfo: any // 打开弹窗时传过来的订单信息
  private formData: any = {
    // 变量需要换下
    companyCode: undefined,
    expressCode: undefined,
    orderCode: undefined,
    companyName: undefined,
  }
  private expressCompanyData: Array<any> = []

  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  // element 表单校验
  // 变量名一致
  private rules = {
    companyCode: [this.requiredRule],
    expressCode: [this.requiredRule]
  }

  private selectData = []
  private tableData = []
  private canSelectRow = (row: any) => !!row.canShip
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '选择', param: 'id', type: 'selection', selectable: this.canSelectRow },
    { title: '序号', type: 'index' },
    // { title: '供应商', param: 'supplierCode' },
    { title: '商品图片', param: 'goodsMainImg' , width: 60 , type:'image' },
    { title: '商品编号', param: 'goodsCode' },
    { title: '商品名称', param: 'goodsName' },
    { title: 'SKU规格', param: 'skuSpecDesc' },
    { title: '商品数量', param: 'count' },
    { title: '退款中/已退款', param: 'refundCount' },
    { title: '已发货数量', param: 'expressQty' },
    { title: '可发货数量', param: 'canShipQty' },
    { title: '发货数量', param: 'deliveryCount',slotName:"deliveryCount",width: 200 },
    { title: '销售金额', param: 'price', formatter: PriceFormat },
    { title: '是否发货', param: 'expressCode', formatter: (e)=> e ? '发货':'未发货' },
    // { title: '活动时销售金额', param: 'activitySalesIntegral', formatter: PriceFormat },
  ]

  @Emit('close')
  private close() {
    this.show = false;
    (this.$refs.form as ElForm).resetFields()
    this.tableData = []
  }

  public async open( data: any | null = {}) {
    this.show = true
    // 打开弹窗时传过来的订单信息
    this.orderInfo = data
    this.formData.expressCode = undefined
    this.formData.companyCode = undefined

    // TODO 加载物流节点信息 需要更新接口
    QueryExpressCompanyList().then(res=>{
      this.expressCompanyData = res
    })

    this.loadDataList()

  }

   public async loadDataList() {
    // 清空选择
    const tb: any = this.$refs.table
    if(tb){
      tb.getTableRef().clearSelection()
    }


    const result = await QueryOrderGoodsDescList({ orderCode: this.orderInfo.orderCode })
    const d = result.list
    d.forEach((d:any) => {
      const count = Number(d.count || 0)
      const refundCount = Number(d.refundCount || 0)
      const expressQty = Number(d.expressQty || 0)
      const canShipQty = Math.max(0, count - refundCount - expressQty)
      d.canShipQty = canShipQty
      d.canShip = canShipQty > 0
      d.deliveryCount = canShipQty
    });
    this.tableData = result.list
    this.$nextTick(()=>{
      // const tb: any = this.$refs.table
      // tb.getTableRef().toggleAllSelection()
      this.tableData.forEach((e: any,index: number)=>{
        if(e.canShip){
          this.selectRow(this.tableData[index])
        }
      })
    })

  }

  private selectRow(row:  any){
    const tb: any = this.$refs.table
    tb.getTableRef().toggleRowSelection(row)
  }

  private selectChange(selection: any) {
    this.selectData = selection.filter((e: any) => e.canShip)
  }

  // 保存按钮
  public async save() {
    console.log(this.selectData)
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      //TODO. 根据输入的值进行参数封装和调用接口
      this.formData.orderCode = this.orderInfo.orderCode
       // 根据code查找对应的公司名称
      const selectedCompany = this.expressCompanyData.find(
        company => company.code === this.formData.companyCode
      );
      this.formData.companyName = selectedCompany.name
            console.log(this.formData)
      const param = {...this.formData}
      // 订单id
      const orderDescIds = this.selectData.map((e:any)=>e.id)
      if(orderDescIds){
        param.orderDescIds = orderDescIds
      }
      if(orderDescIds.length == 0){
        this.$message.error("请勾选商品")
        return
      }

      UpdateExpressOrder(param).then(res=>{
        this.$message.success("提交成功")
        this.close()
      })
    })
  }

}
